module.exports = {
  ColorMatrix: require("./ColorMatrix")
};
